import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import TitleCase from "components/formatting/TitleCase";
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";

interface RadarChartTooltipProps {
  data: any;
  index: number | null;
}

export default function RadarChartTooltip(props: RadarChartTooltipProps): JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { data, index }: RadarChartTooltipProps = props;

  const dataPoint = data?.[index];

  return (
    <Box>
      {/* Title */}
      <Typography variant="h4">
        <TitleCase text={dataPoint?.subject}/>
      </Typography>

      {/* Value */}
      <Typography>
         {i18n.t("record-count")}: 
         <Box sx={{ display: "inline-block", ml: 1 }}>
           <ISONumber number={dataPoint?.count} sx={{ fontWeight: "bold" }}/>  
         </Box>
       </Typography>

      {/* Percentage */}
       <Typography>
         {i18n.t("percent")}:
         <Box sx={{ display: "inline-block", ml: 1 }}>
           <ISOPercentage value={dataPoint?.percent / 100} sx={{ fontWeight: "bold" }} />
         </Box>
       </Typography>
    </Box>
  );
}